var collapsible_list_pair_rtlignore_default = {
  "container": "xOwNu",
  "title": "-B-1s",
  "viewerContainer": "DH6RM",
  "titleContainer": "oA9WR",
  "content": "JfKN6",
  "expandIcon": "UROY1",
  "dndIcon": "TnGnn",
  "RTL": "tYfwx",
  "LTR": "Hj-rs",
  "itemContainer": "GuFtb",
  "itemContainerViewer": "BvlPu",
  "mouseDown": "obAUJ",
  "innerEditor": "FMgYB",
  "item": "hVEET",
  "floatingAddPluginMenuWrapper": "xAjuw"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
